class PricingModule {
    constructor() {
        document.addEventListener('alpine:init', () => {
            Alpine.data('pricingModule', (rangeValue = 0, currencyCode = '') => ({
                rangeValue: rangeValue,
                activeSolution: null,
                currencyCode: currencyCode,

                get rangeValueSuffix() {
                    if (this.rangeValue === this.$refs.range.getAttribute('max')) {
                        return '+&nbsp;members'
                    }

                    return '&nbsp;members'
                },

                get tooltipPosition() {
                    const thumbWidth = 26
                    const min = this.$refs.range.getAttribute('min')
                    const max = this.$refs.range.getAttribute('max')
                    const fraction = (this.rangeValue - min) / (max - min)

                    return `calc(${fraction * 100}% + ${(0.5 - fraction) * thumbWidth}px)`
                },

                selectSolution(solution) {
                    if (this.activeSolution === solution) {
                        this.activeSolution = 0
                    } else {
                        this.activeSolution = solution
                    }
                },

                highlightSolution(min, max) {
                    if (this.rangeValue < min || this.rangeValue > max) {
                        return false
                    }

                    return true
                }
            }))
        })
    }
}

export default PricingModule
